var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_Default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0008 0 72 0 72 47.9996 0.0008 47.9996"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_Default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0008,35.5716 L72.0008,23.9996 L72.0008,12.4276 L72.0008,4.0116 C72.0008,1.7956 70.2048,-0.0004 67.9888,-0.0004 L51.1788,-0.0004 L39.1788,-0.0004 L4.0128,-0.0004 C1.7948,-0.0004 0.0008,1.7956 0.0008,4.0116 L0.0008,12.4856 L0.0008,23.9996 L0.0008,35.5156 L0.0008,43.9876 C0.0008,46.2036 1.7948,47.9996 4.0128,47.9996 L38.8968,47.9996 L50.8968,47.9996 L67.9888,47.9996 C70.2048,47.9996 72.0008,46.2036 72.0008,43.9876 L72.0008,35.5716 Z",
    id: "Fill-1",
    fill: "#97D8EB",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2136,24.0002 C17.2136,13.6242 25.6256,5.2142 35.9996,5.2142 C46.3756,5.2142 54.7856,13.6242 54.7856,24.0002 C54.7856,34.3762 46.3756,42.7862 35.9996,42.7862 C25.6256,42.7862 17.2136,34.3762 17.2136,24.0002",
    id: "Fill-4",
    fill: "#ACE0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6316,21.596 L21.6316,18.72 L21.6316,15.844 C21.6316,14.858 20.4296,14.054 18.9636,14.054 L11.8036,14.054 C9.3336,14.054 7.3096,14.862 7.3096,15.85 L7.3096,18.72 L7.3096,21.59 C7.3096,22.578 9.3196,23.388 11.7736,23.388 L18.9356,23.388 C20.4196,23.388 21.6316,22.582 21.6316,21.596",
    id: "Fill-6",
    fill: "#FFF8A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6316,21.596 L21.6316,18.72 L21.6316,15.844 C21.6316,14.858 20.4296,14.054 18.9636,14.054 L11.8036,14.054 C9.3336,14.054 7.3096,14.862 7.3096,15.85 L7.3096,18.72 L7.3096,21.59 C7.3096,22.578 9.3196,23.388 11.7736,23.388 L18.9356,23.388 C20.4196,23.388 21.6316,22.582 21.6316,21.596 Z",
    id: "Stroke-8",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7.3094 16.4778 10.5874 16.4778 10.5874 21.1798 7.3094 21.1798"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "21.5964 16.4778 18.3184 16.4778 18.3184 21.1798 21.5964 21.1798"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-14",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "13.3738 14.053 13.3738 16.117 15.5698 16.117 15.5698 14.053"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-16",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "15.5692 23.387 15.5692 21.323 13.3732 21.323 13.3732 23.387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3094,18.72 L10.5874,18.72",
    id: "Stroke-18",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.323,18.72 L21.601,18.72",
    id: "Stroke-20",
    stroke: "#C4A006",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "1234-5678-9012-3456",
    fontFamily: "Menlo-Bold, Menlo",
    fontSize: 5,
    fontWeight: "bold",
    fill: "#006B84"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.4628,
    y: 38.1057109
  }, "1234 5678 9012 3456")), /*#__PURE__*/React.createElement("text", {
    id: "1234-5678-9012-3456",
    fontFamily: "Menlo-Bold, Menlo",
    fontSize: 5,
    fontWeight: "bold",
    fill: "#00BBDD"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.23219,
    y: 37.8013057
  }, "1234 5678 9012 3456"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "assets/media/unknown.612d1acad3b8d704b31daebaa35bd1f1.svg";
export { ForwardRef as ReactComponent };